import React from 'react';
import { truncate, size } from 'lodash';
import TooltipWrapper from '../../../common/components/Form/TooltipWrapper';

const tooltipTextStyle = {
  wordWrap: 'break-word',
  width: 'auto',
  maxWidth: 190,
  fontSize: 13,
  fontFamily: 'Roboto',
};

export function HintableText({ text = '', hintText = '', maxTextSize = 25 }) {
  const textSize = size(text);
  const truncatedText = truncate(text, { length: maxTextSize });

  return textSize > maxTextSize ? (
    <TooltipWrapper tip={<div style={tooltipTextStyle}>{hintText || text}</div>} position="auto-end" arrow interactive>
      {truncatedText}
    </TooltipWrapper>
  ) : (
    <div className="desc">{text}</div>
  );
}

export default HintableText;
